const getFileExtension = (fileName: string) => fileName.toLowerCase().split(".").pop() ?? "";

const parseJsonRows = (text: string): Record<string, unknown>[] | null => {
	try {
		const parsed: unknown = JSON.parse(text);
		const rows = Array.isArray(parsed)
			? parsed
			: typeof parsed === "object" && parsed && Array.isArray((parsed as { data?: unknown }).data)
				? (parsed as { data: unknown[] }).data
				: null;
		if (!rows || !rows.every(row => typeof row === "object" && row !== null && !Array.isArray(row))) return null;
		return rows as Record<string, unknown>[];
	} catch {
		return null;
	}
};

const serializeCsvRows = (rows: Record<string, unknown>[], delimiter = ";") => {
	const headers = rows.reduce<string[]>((result, row) => {
		Object.keys(row).forEach(header => {
			if (!result.includes(header)) result.push(header);
		});
		return result;
	}, []);
	const escapeValue = (value: unknown) => {
		const text = value === undefined || value === null ? "" : typeof value === "object" ? JSON.stringify(value) : String(value);
		return text.includes(delimiter) || /["\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
	};

	return [headers.map(escapeValue).join(delimiter), ...rows.map(row => headers.map(header => escapeValue(row[header])).join(delimiter))].join("\r\n");
};

export const prepareFileDownloadBlob = async (fileName: string, sourceBlob: Blob, sourceText?: string) => {
	if (getFileExtension(fileName) !== "csv") return sourceBlob;

	// Some file endpoints return CSV rows wrapped in { data: [...] } despite the
	// .csv extension. Convert that payload to actual CSV before saving it.
	const text = sourceText ?? (await sourceBlob.text());
	const jsonRows = parseJsonRows(text);
	const csvText = jsonRows ? serializeCsvRows(jsonRows) : text.replace(/^\uFEFF/, "");
	return new Blob(["\uFEFF", csvText], { type: "text/csv;charset=utf-8" });
};
